import { createFileRoute } from "@tanstack/react-router";

import { TriggersSettings } from "../components/settings/TriggersSettings";

export const Route = createFileRoute("/settings/triggers")({
  component: TriggersSettings,
});
